// Shared canvas helpers for the mockup generators (chat, comments, notifications).
//
// These lived inside BrowserChatGenerator until a third and fourth mockup tool needed the same
// text wrapping and rounded rectangles. Kept deliberately tiny and dependency-free: every mockup
// tool is a `dynamic()` chunk, so anything imported here ships with each of them.

export function wrapText(ctx: CanvasRenderingContext2D, text: string, maxWidth: number): string[] {
  const lines: string[] = [];
  const words = text.split(' ');
  let current = '';
  for (const word of words) {
    const test = current ? `${current} ${word}` : word;
    if (ctx.measureText(test).width > maxWidth && current) {
      lines.push(current);
      current = word;
    } else {
      current = test;
    }
  }
  if (current) lines.push(current);
  return lines;
}

export function roundRectPath(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  r: number,
) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

// One message/comment per line, a leading ">" marks it as the author's own.
export function parseLines(input: string): { me: boolean; text: string }[] {
  return input
    .split('\n')
    .map((line) => line.trimEnd())
    .filter((line) => line.trim() !== '')
    .map((line) => {
      const me = line.startsWith('>');
      return { me, text: me ? line.slice(1).trim() : line.trim() };
    });
}
